export function initFAQ(): void {
  document.querySelectorAll('.faq-question').forEach((question) => {
    question.addEventListener('click', () => {
      const item = question.closest('.faq-item');
      item?.classList.toggle('active');
    });
  });
}
